import React, { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { initAlfaMetrics } from '@alfa-bank/newclick-alfa-metrics';
import { initConfig } from '@alfa-bank/newclick-core/utils';

import { alfaMetricsConfig } from '../../../alfa-metrics-config';
import { HydrateLandingVariant } from '../../components/hydrate-landing-variant';

export function initApp(RootComponent: React.FC<unknown>) {
    try {
        const config = window.appConfig;
        const container = document.getElementById('react-app')!;

        initConfig(config);

        try {
            initAlfaMetrics({
                appId: config.appId,
                environment: config.nodeEnv,
                config: alfaMetricsConfig,
                metricsDomain: config.metricsDomain,
            });
        } catch {
            // eslint-disable-next-line no-console
            console.error('Ошибка при инициализации метрики');
        }

        hydrateRoot(
            container,
            <StrictMode>
                <HydrateLandingVariant landingVariant={config.landingVariant}>
                    <RootComponent />
                </HydrateLandingVariant>
            </StrictMode>,
        );
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Ошибка монтирования приложения', error);
    }
}
